import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/PoweringFutureIGBTModulesHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-IGBT3.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pfig { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .pfig-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .pfig-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .pfig-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .pfig-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .pfig-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .pfig-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .pfig-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .pfig-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .pfig-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .pfig-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .pfig-bc-item:hover { color: #EB2019; }
  .pfig-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .pfig-bc-sep img { width: 24px; height: 24px; display: block; }
  .pfig-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .pfig-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .pfig-main-section { padding: 80px 0 120px 0; }
  .pfig-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .pfig-article { flex: 1; min-width: 0; }

  .pfig-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .pfig-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .pfig-meta-item:last-child { border-right: none; padding-right: 0; }
  .pfig-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .pfig-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 20px;
  }

  .pfig-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .pfig-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .pfig-article-body p { margin-bottom: 20px; }
  .pfig-article-body p:last-child { margin-bottom: 0; }

  .pfig-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }
  .pfig-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet ul list */
  .pfig-article-body ul {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .pfig-article-body ul li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .pfig-article-body ul li::before {
    content: '•';
    font-weight: 700; color: #202020;
    flex-shrink: 0; font-size: 18px; line-height: 160%;
  }
  .pfig-article-body ul li > span { flex: 1; }

  .pfig-article-body strong { font-weight: 600; color: #202020; }

  /* Comparison table */
  .pfig-table-wrapper {
    width: 100%; overflow-x: auto; margin: 20px 0 30px 0;
  }
  .pfig-table {
    width: 100%; border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; color: #202020;
  }
  .pfig-table th, .pfig-table td {
    border: 1px solid #B8B8B8;
    padding: 20px 30px;
    text-align: left;
    line-height: 120%;
  }
  .pfig-table th {
    font-weight: 600; background: #F6F6F6;
  }
  .pfig-table td { font-weight: 400; }
  .pfig-table tbody tr:nth-child(odd)  { background-color: #ffffff; }
  .pfig-table tbody tr:nth-child(even) { background-color: #F6F6F6; }

  .pfig-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .pfig-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .pfig-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .pfig-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .pfig-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .pfig-nav-btn:hover { color: #EB2019; }
  .pfig-nav-btn img { width: 40px; height: 40px; display: block; }

  .pfig-share-icons { display: flex; align-items: center; gap: 20px; }
  .pfig-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .pfig-share-icon:hover { opacity: 0.85; }
  .pfig-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .pfig-sidebar { flex: 0 0 475px; }
  .pfig-sidebar-block { margin-bottom: 60px; }
  .pfig-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .pfig-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .pfig-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .pfig-recent-item:hover .pfig-recent-title { color: #EB2019; }
  .pfig-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .pfig-recent-body { flex: 1; min-width: 0; }
  .pfig-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .pfig-social-icons { display: flex; align-items: center; gap: 30px; }
  .pfig-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .pfig-social-icon:hover { opacity: 0.8; }
  .pfig-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .pfig-hero             { height: 350px; }
    .pfig-hero-content     { padding: 0 32px; }
    .pfig-hero-title       { font-size: 30px; }
    .pfig-hero-divider     { width: 100%; max-width: 575px; }
    .pfig-breadcrumb       { padding: 24px 0 0 0; }
    .pfig-breadcrumb-inner { padding: 0 32px; }
    .pfig-inner            { padding: 0 32px; }
    .pfig-main-section     { padding: 48px 0 60px 0; }
    .pfig-main-row         { flex-direction: column; gap: 48px; }
    .pfig-sidebar          { flex: none; width: 100%; }
    .pfig-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .pfig-hero             { height: 360px; }
    .pfig-hero-content     { padding: 0 16px; }
    .pfig-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .pfig-hero-divider     { width: 100%; }
    .pfig-hero-subtitle    { font-size: 14px; }
    .pfig-breadcrumb       { padding: 30px 0 0 0; }
    .pfig-breadcrumb-inner { padding: 0 16px; }
    .pfig-bc-item          { font-size: 14px; gap: 14px; }
    .pfig-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .pfig-bc-sep img       { width: 22px; height: 22px; }
    .pfig-inner            { padding: 0 16px; }
    .pfig-main-section     { padding: 30px 0 60px 0; }
    .pfig-main-row         { flex-direction: column; gap: 60px; }
    .pfig-sidebar          { flex: none; width: 100%; }
    .pfig-article-title    { font-size: 20px; margin-bottom: 15px; }
    .pfig-article-body     { font-size: 14px; }
    .pfig-article-body p   { margin-bottom: 15px; }
    .pfig-article-body ul  { margin: 20px 0 20px 0; gap: 10px; }
    .pfig-article-body ul li { font-size: 14px; }
    .pfig-article-body strong { font-size: 14px; }
    .pfig-table            { font-size: 12px; }
    .pfig-table th, .pfig-table td { padding: 33px 8px; }
    .pfig-meta-item        { font-size: 14px; }
    .pfig-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .pfig-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .pfig-h2               { font-size: 16px; margin: 20px 0 0px 0; }
    .pfig-heading          { font-size: 16px; margin: 30px 0 15px 0; }
    .pfig-nav-btn img      { width: 24px; height: 24px; }
    .pfig-nav-btn          { font-size: 14px; }
    .pfig-share-icon img   { width: 34px; height: 34px; }
    .pfig-sidebar-title    { font-size: 20px; }
    .pfig-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function PoweringFutureIGBTModules() {
  return (
    <div className="pfig">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="pfig-hero">
        <img className="pfig-hero-bg" src={HeroBgImg} alt="Powering the Future Why IGBT Modules Are the Silent Heroes Behind Smart Energy Hero" />
        <div className="pfig-hero-overlay" />
        <div className="pfig-hero-content">
          <h1 className="pfig-hero-title">
            Powering the Future: Why IGBT Modules Are the Silent Heroes Behind Smart Energy
          </h1>
          <hr className="pfig-hero-divider" />
          <p className="pfig-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="pfig-breadcrumb" aria-label="Breadcrumb">
        <div className="pfig-breadcrumb-inner">
          <a href="/" className="pfig-bc-item">Home</a>
          <span className="pfig-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="pfig-bc-item">News &amp; Updates</a>
          <span className="pfig-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="pfig-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="pfig-main-section">
        <div className="pfig-inner">
          <div className="pfig-main-row">

            {/* ── ARTICLE ── */}
            <article className="pfig-article">

              {/* Meta bar */}
              <div className="pfig-meta-bar">
                <span className="pfig-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="pfig-meta-item"><img src={CalendarIcon} alt="date" /> May 27, 2025</span>
                <span className="pfig-meta-item"><img src={ClockIconImg} alt="time" /> 12:08 pm</span>
                <span className="pfig-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="pfig-article-title">
                Powering the Future: Why IGBT Modules Are the Silent Heroes Behind Smart Energy
              </h1>

              {/* Body */}
              <div className="pfig-article-body">

                <span className="pfig-heading">Powering the Future: Why IGBT Modules Are the Silent Heroes Behind Smart Energy</span>

                <p>In today's world, everything is becoming smarter and more energy-efficient — from electric cars to solar panels. But behind the scenes, there's one small but powerful part making it all possible: the <a href="/igbt-module" className="pfig-red-link-plain">IGBT module</a> . It stands for Insulated Gate Bipolar Transistor, but all you need to know is that it helps control and manage electricity more efficiently. Whether it's saving energy, improving performance, or powering the latest technology, IGBT modules help make our devices work better and last longer. At <a href="/ador-powertron" className="pfig-red-link-plain">Ador Powertron</a> , we design advanced IGBT-based solutions like the <strong>Precicon S</strong> — built to deliver smooth, reliable power for demanding industrial systems such as Electrostatic Precipitators (ESPs), ensuring cleaner operations and reduced energy waste.</p>

                {/* Article image */}
                <img className="pfig-article-img" src={ArticleImg} alt="Powering the Future IGBT Modules Silent Heroes Smart Energy" />

                <span className="pfig-heading">What Is an IGBT Module?</span>

                <p>Imagine a compact, all-in-one solution for controlling large amounts of electrical power. That's what an IGBT module does. It's a pre-assembled package that includes one or more IGBT transistors, often combined with diodes and safety circuits — all built to handle high voltage and current without breaking a sweat. They're like the muscle and brain behind your power system — controlling flow, minimizing energy loss, and protecting equipment from damage.</p>

                <span className="pfig-heading">Key Features of IGBT Modules</span>

                <p>Here's why engineers and industries rely on IGBT modules:</p>

                <ul>
                  <li><span><strong>High Power Handling:</strong> These modules are built for tough jobs — like running industrial machines or managing EV powertrains.</span></li>
                  <li><span><strong>Efficient Switching:</strong> Fast, clean switching means less wasted energy and smoother performance.</span></li>
                  <li><span><strong>Smart Heat Management:</strong> Designed to manage and dissipate heat effectively, so they stay cool even under pressure.</span></li>
                  <li><span><strong>Built-in Protection:</strong> Most come with safety features to guard against overcurrent, short circuits, and voltage spikes.</span></li>
                </ul>

                <span className="pfig-heading">Why Are IGBT Modules So Popular?</span>

                <p>They combine the best of both worlds: the efficiency and speed of MOSFETs, and the high current capacity of BJTs. This gives IGBT modules several distinct advantages:</p>

                <ul>
                  <li><span>Lower energy loss</span></li>
                  <li><span>Fast operation</span></li>
                  <li><span>Durability in harsh environments</span></li>
                  <li><span>Space-saving design</span></li>
                </ul>

                <span className="pfig-heading">Where You'll Find IGBT Modules in Action</span>

                <p>These modules are incredibly versatile. You'll find them powering systems in:</p>

                <ul>
                  <li><span>Industrial Motor Drives (e.g., VFDs)</span></li>
                  <li><span>Solar Inverters &amp; Wind Turbines</span></li>
                  <li><span>Electric Vehicles (EVs)</span></li>
                  <li><span>UPS &amp; Backup Power Systems</span></li>
                  <li><span>HVAC Systems</span></li>
                  <li><span>Battery Energy Storage Systems (BESS)</span></li>
                </ul>

                <span className="pfig-heading">Choosing the Right IGBT Module: A Comparison Table</span>

                <div className="pfig-table-wrapper">
                  <table className="pfig-table">
                    <thead>
                      <tr>
                        <th>Feature</th>
                        <th>What To Look For</th>
                        <th>Why It Matters</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Voltage &amp; Current Ratings</td>
                        <td>Match Your System's Power Requirements</td>
                        <td>Prevents Overload Or Failure</td>
                      </tr>
                      <tr>
                        <td>Switching Frequency</td>
                        <td>Based On Your Application</td>
                        <td>Balances Speed And Efficiency</td>
                      </tr>
                      <tr>
                        <td>Thermal Resistance</td>
                        <td>Lower Is Better</td>
                        <td>Ensures Long-Lasting Performance</td>
                      </tr>
                      <tr>
                        <td>Physical Form Factor</td>
                        <td>Compact, Compatible Size</td>
                        <td>Fits Easily Into System Layout</td>
                      </tr>
                      <tr>
                        <td>Integrated Protection</td>
                        <td>Overcurrent, Short-Circuit, Etc.</td>
                        <td>Reduces Risk And Extends Lifespan</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span className="pfig-heading">Future Trends in IGBT Modules</span>

                <p>The IGBT module landscape is evolving. With the push toward green energy and electrification, newer modules are becoming more compact, efficient, and industry-specific. For example, Ador Powertron's IGBT solutions are tailored for air pollution control using ESPs — offering cleaner outputs and smarter energy use.</p>

                <span className="pfig-heading">Some major trends shaping the future of IGBT modules include:</span>

                <p>These modules are incredibly versatile. You'll find them powering systems in:</p>

                <ul>
                  <li><span><strong>Silicon Carbide (SiC)</strong> IGBT modules for higher voltage and temperature performance</span></li>
                  <li><span><strong>AI-integrated power systems</strong> that adjust operation in real time</span></li>
                  <li><span><strong>Enhanced thermal interfaces</strong> and liquid-cooled modules</span></li>
                  <li><span><strong>Modular plug-and-play units</strong> for simplified replacement and upgrades</span></li>
                </ul>

                <span className="pfig-heading">FAQs About IGBT Modules</span>

                <span className="pfig-h2">Q1: What's the difference between an IGBT module and a single IGBT?</span>

                <p>A: A single IGBT is just one transistor. An IGBT module combines multiple IGBTs (plus diodes and protection circuits) into a single, compact unit. It's more efficient, reliable, and easier to install.</p>

                <span className="pfig-h2">Q2: Can IGBT modules be used in both AC and DC systems?</span>

                <p>A: Yes! They're designed to handle conversions between AC and DC, as well as DC-to-DC — making them ideal for a wide range of applications.</p>

                <span className="pfig-h2">Q3: How do they help with energy efficiency in solar or wind systems?</span>

                <p>A: IGBT modules ensure that power from solar panels or wind turbines is converted cleanly and with minimal losses — so more energy reaches the grid or your battery.</p>

                <span className="pfig-h2">Q4: What should I know about heat management in these modules?</span>

                <p>A: Heat is a big deal in power electronics. IGBT modules are built with thermal pads or heat sinks to prevent overheating and extend lifespan.</p>

                <span className="pfig-heading">Final Thoughts</span>

                <p>IGBT modules might not be visible in your everyday tech, but they're doing some of the most important work behind the scenes — ensuring efficiency, reliability, and safety. Whether you're managing massive power systems or advancing vehicles, or building renewable energy solutions, IGBT modules are at the core of modern power systems.</p>

                <p>At <a href="/ador-powertron" className="pfig-red-link-plain">Ador Powertronc</a>, we're proud to offer high-quality, performance-driven IGBT modules that meet the evolving needs of industries and industries. With a strong focus on reliability, customization, and efficiency, our IGBT modules are powering cleaner systems and cleaner tomorrow.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="pfig-bottom-row">
                <div className="pfig-bottom-nav">
                  <a href="/news/previous" className="pfig-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="pfig-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="pfig-share-icons">
                  <a href="#" className="pfig-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="pfig-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="pfig-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="pfig-sidebar">

              {/* Recent Posts */}
              <div className="pfig-sidebar-block">
                <p className="pfig-sidebar-title">Recent Posts</p>
                <div className="pfig-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="pfig-recent-item">
                      <img src={post.img} alt={post.title} className="pfig-recent-img" />
                      <div className="pfig-recent-body">
                        <span className="pfig-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="pfig-sidebar-block">
                <p className="pfig-sidebar-title">Social Media</p>
                <div className="pfig-social-icons">
                  <a href="#" className="pfig-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="pfig-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}